import React from 'react'
import styled, { css } from 'styled-components'

import { media } from '../../utils/style-utils'

export const PageContainer = css`
	${media.desktopLg`
    margin: 0 40px;
    `}
	${media.desktopMd`
    margin: 0 24px;
  `}

  ${media.desktopSm`
    margin: 0 24px;
  `}

  ${media.tablet`
    margin: 0 16px;
  `}

  ${media.phone`
    margin: 0 8px;
  `}
`
